import type { RegistrationStatus } from '@contract';
import type { Tone } from '@/lib/status';

/** The short word for where a registration stopped, for a list or a chip. */
export const STOP_LABEL: Record<RegistrationStatus['code'], string> = {
  no_kyc: 'Has not started the ID check',
  kyc_not_begun: 'Has not started the ID check',
  kyc_left: 'Left the ID check',
  kyc_expired: 'ID check expired',
  kyc_in_review: 'ID check in review',
  kyc_declined: 'ID check declined',
  kyc_passed_not_recorded: 'ID check passed, not recorded',
  identity_missing: 'Personal details missing',
  pin_missing: 'PIN not set',
};

/** Failed is red, someone else is on it is blue, the customer stopping is neutral (§9.4). */
export const STOP_TONE: Record<RegistrationStatus['tone'], Tone> = {
  failed: 'danger',
  waiting: 'info',
  stalled: 'neutral',
};

/** The five steps a customer walks; `reached` is how many are done. */
export const REGISTRATION_STEPS = [
  { key: 'signed_up', label: 'Signed up' },
  { key: 'kyc_verified', label: 'ID check' },
  { key: 'identity_submitted', label: 'Personal details' },
  { key: 'pin', label: 'PIN' },
  { key: 'registered', label: 'Registered' },
] as const;

/** How many of the five steps are done when registration stopped at `step`. */
export function stepsDone(step: RegistrationStatus['step']): number {
  switch (step) {
    case 'started':
      return 1;
    case 'kyc_verified':
      return 2;
    default:
      return 3;
  }
}
